/**
 * CompassLogo — the compass-rose app icon as an inline SVG so it follows the
 * theme: the tile and the south rose point flip with light/dark via the
 * --logo-* CSS variables (public/icon.svg stays dark-only for PWA/favicons).
 */
export function CompassLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" fill="none" className={className} aria-hidden="true">
      <rect width="512" height="512" rx="96" fill="var(--logo-tile)" />
      <circle cx="256" cy="256" r="180" stroke="#3b82f6" strokeWidth="6" opacity="0.4" />
      <circle cx="256" cy="256" r="140" stroke="#3b82f6" strokeWidth="3" opacity="0.6" />
      <g transform="translate(256 256)">
        {/* N (red, top) */}
        <path d="M 0 -160 L 28 -28 L 0 0 Z" fill="#ef4444" />
        <path d="M 0 -160 L -28 -28 L 0 0 Z" fill="#dc2626" />
        {/* S (theme-aware, bottom) */}
        <path d="M 0 160 L 28 28 L 0 0 Z" fill="var(--logo-rose-s)" />
        <path d="M 0 160 L -28 28 L 0 0 Z" fill="var(--logo-rose-s2)" />
        {/* E (blue, right) */}
        <path d="M 160 0 L 28 28 L 0 0 Z" fill="#3b82f6" />
        <path d="M 160 0 L 28 -28 L 0 0 Z" fill="#2563eb" />
        {/* W (blue, left) */}
        <path d="M -160 0 L -28 28 L 0 0 Z" fill="#2563eb" />
        <path d="M -160 0 L -28 -28 L 0 0 Z" fill="#3b82f6" />
        {/* diagonal arms */}
        <g opacity="0.5">
          <path d="M 113 -113 L 14 -14 Z" stroke="#64748b" strokeWidth="3" />
          <path d="M 113 113 L 14 14 Z" stroke="#64748b" strokeWidth="3" />
          <path d="M -113 113 L -14 14 Z" stroke="#64748b" strokeWidth="3" />
          <path d="M -113 -113 L -14 -14 Z" stroke="#64748b" strokeWidth="3" />
        </g>
        <circle cx="0" cy="0" r="8" fill="var(--logo-tile)" stroke="#3b82f6" strokeWidth="2" />
      </g>
      <text x="256" y="115" fontFamily="ui-monospace,Menlo,monospace" fontSize="22" fontWeight="700"
        fill="var(--logo-rose-s2)" textAnchor="middle">N</text>
    </svg>
  )
}
